<template>
  <v-card>
    <v-toolbar
      dark
      dense
      flat
      color="primary"
    >
      <v-spacer />
      <v-toolbar-title v-text="value.name" />
      <v-spacer />
    </v-toolbar>
    <v-list nav dense>
      <!-- Players -->
      <v-list-item
        color="accent"
        :to="`/animation/session/${value.id}/players`"
      >
        <v-list-item-icon>
          <v-icon>mdi-account-multiple</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title v-text="$t('animation.menu.players')" />
        </v-list-item-content>
      </v-list-item>

      <!-- Games --->
      <game-session-list-item
        v-for="game in gameList"
        :key="game.name"
        :game="game"
        :session-opened="value.status === 'opened'"
      />

      <!-- Play/Pause -->
      <v-list-item v-if="value.status === 'opened'">
        <play-pause-session-button :session="value" />
      </v-list-item>
    </v-list>
  </v-card>
</template>

<script>
import GameSessionListItem from '../components/session-menu/GameSessionListItem'
import PlayPauseSessionButton from '../components/session-menu/PlayPauseSessionButton'

export default {
  name: 'SessionMenu',
  components: {
    GameSessionListItem,
    PlayPauseSessionButton,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  computed: {
    gameList () {
      return this.value.gameList.map((game, index) => ({
        ...game,
        position: index + 1,
        sessionId: this.value.id,
      }))
    },
  },
}
</script>
